import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: 'https://yubang.torieo.com',
  timeout: 30000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    console.log('[API] 响应数据:', res)
    if (res.code !== 200) {
      if (res.code === 401) {
        console.log('[API] 收到 401，清除登录信息')
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    console.error('[API] 响应错误:', error)
    if (error.response) {
      if (error.response.status === 401) {
        console.log('[API] 收到 401 状态码')
        Message.error('登录已过期,请重新登录')
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
      } else if (error.response.status === 403) {
        Message.error('没有权限访问')
      } else if (error.response.status === 404) {
        Message.error('请求的资源不存在')
      } else if (error.response.status === 500) {
        Message.error('服务器内部错误')
      } else {
        Message.error((error.response.data && error.response.data.message) || '请求失败')
      }
    } else if (error.code === 'ECONNABORTED') {
      Message.error('请求超时')
    } else {
      Message.error('网络错误,请检查网络连接')
    }
    return Promise.reject(error)
  }
)

// PC端API
export const pc = {
  // 登录
  login: data => {
    return service.post('/api/pc/login', data)
  },

  // 退出登录
  logout: () => {
    return service.post('/api/pc/logout')
  },

  // 获取统计数据
  getStats: () => {
    return service.get('/api/pc/stats')
  },

  // 获取最近合同
  getRecentContracts: () => {
    return service.get('/api/pc/recent-contracts')
  },

  // 获取最近文件
  getRecentFiles: () => {
    return service.get('/api/pc/recent-files')
  },

  // 用户管理
  getUserList: () => {
    return service.get('/api/pc/users')
  },

  // 获取微信端用户列表(用于合同参与方选择)
  getWechatUserList: () => {
    return service.get('/api/pc/users/wechat')
  },

  addUser: data => {
    return service.post('/api/pc/users', data)
  },

  updateUser: data => {
    return service.put('/api/pc/users', data)
  },

  deleteUser: id => {
    return service.post('/api/pc/users/delete', { id })
  },

  resetPassword: data => {
    return service.post('/api/pc/users/reset-password', data)
  },

  // 修改密码
  changePassword: data => {
    return service.post('/api/pc/change-password', data)
  },

  // 合同管理
  getContractList: params => {
    return service.get('/api/pc/contracts', { params })
  },

  addContract: data => {
    return service.post('/api/pc/contracts', data)
  },

  updateContract: data => {
    return service.put('/api/pc/contracts', data)
  },

  deleteContract: id => {
    console.log('[API] 调用删除合同接口, id:', id, 'URL:', `/api/pc/contracts/delete`)
    return service.post('/api/pc/contracts/delete', { id })
  },

  // 文件管理
  getFileList: params => {
    return service.get('/api/pc/files', { params })
  },

  deleteFile: id => {
    return service.post('/api/pc/files/delete', { id })
  }
}

export default {
  pc,
  service
}



// WEBPACK FOOTER //
// ./src/api/index.js